import {
    GetPageAttachmentsArgs,
    DeleteAttachArgs,
    AttachFilesArgs,
} from '~shared/schema/wiki/actions/attachments';

import {i18n} from '~ui/components/AttachmentsPanel/i18n';

import {createThunk, makeThunkErrorHandler} from '~ui/store/utils';

const PAGE_SIZE = 50;

export const getAttachments = createThunk(
    'attachments/get',
    async ({pageId, cursor}: GetPageAttachmentsArgs, {extra: {sdk}}) => {
        return sdk.wiki
            .getPageAttachments({
                cursor,
                pageSize: PAGE_SIZE,
                pageId,
            })
            .catch(
                makeThunkErrorHandler({
                    name: 'get-attachments',
                    title: i18n('error-get-title'),
                }),
            );
    },
);

export const deleteAttachment = createThunk(
    'attachments/delete',
    async ({pageId, attachmentId}: DeleteAttachArgs, {extra: {sdk}}) => {
        return sdk.wiki
            .deleteAttachment({
                attachmentId,
                pageId,
            })
            .catch(
                makeThunkErrorHandler({
                    name: 'get-attachments',
                    title: i18n('error-delete-title'),
                }),
            );
    },
);

export const attachFiles = createThunk(
    'attachments/attach',
    ({pageId, uploadSessions}: AttachFilesArgs, {extra: {sdk}}) => {
        return sdk.wiki.attachFiles({
            pageId,
            uploadSessions,
        });
    },
);
